import { useMemo } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";
import { moneyFull } from "@/lib/format";

const COLORS = ["#002B49", "#0055FF", "#10B981", "#F59E0B", "#94A3B8", "#CBD5E1"];
const LABELS = {
  traffic_value: "Traffic",
  lead_value: "Leads",
  revenue_value: "Revenue",
  seo_value: "SEO / Links",
  brand_value: "Brand / PR",
  risk_reduction_value: "Risk (soft)",
};

const TOOLTIP_STYLE = { background: "#0F172A", border: "none", color: "#fff", fontSize: 12, fontFamily: "JetBrains Mono" };
const LEGEND_WRAPPER = { fontSize: 11, color: "#475569", fontFamily: "Manrope" };

export default function BenefitBreakdownChart({ benefits, currency, height = 240 }) {
  const data = useMemo(() =>
    Object.entries(benefits)
      .filter(([, v]) => v > 0)
      .map(([k, v], i) => ({ name: LABELS[k] || k, value: v, fill: COLORS[i % COLORS.length] })),
  [benefits]);

  const containerStyle = useMemo(() => ({ width: "100%", height }), [height]);
  const formatTooltip = useMemo(() => (v, name) => [moneyFull(v, currency), name], [currency]);

  if (data.length === 0) {
    return <div className="text-slate-400 text-sm">No positive benefit components yet.</div>;
  }

  return (
    <div style={containerStyle}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            innerRadius="55%"
            outerRadius="85%"
            paddingAngle={1}
            dataKey="value"
            stroke="#fff"
          >
            {data.map((d) => (
              <Cell key={d.name} fill={d.fill} />
            ))}
          </Pie>
          <Tooltip contentStyle={TOOLTIP_STYLE} formatter={formatTooltip} />
          <Legend verticalAlign="bottom" iconType="square" wrapperStyle={LEGEND_WRAPPER} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
